<script lang="ts">
    import type {Rec} from 'src/typings';
    import {getInjector, getLocalization} from 'src/core';
    import {KpCollectionBulkInsertButtonPresenter} from './kp-collection-bulk-insert-button.presenter';

    export let records: Rec[];

    const localize = getLocalization();
    const presenter = getInjector().getByClass(KpCollectionBulkInsertButtonPresenter);

    let isDisabled = false;

    async function insert() {
        isDisabled = true;
        try {
            await presenter.insertMultipleToCollection(records);
        } finally {
            isDisabled = false;
        }
    }
</script>

<button type="button"
        class="btn btn-default btn-xs"
        disabled={isDisabled}
        on:click={insert}>
    {localize(/* @kp-localization recordCollections.AddSelectedToCollection */ 'recordCollections.AddSelectedToCollection')}
</button>